import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { BlockComponent } from "@components/container-block/block.component";
import { HotDocComponent } from "@components/hot-doc/hot-doc.component";
import { HotDoc } from "~app/common/components/hot-doc/hotdoc/doc";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ProduktdefinitionViewModel } from "../../../models/ProduktdefinitionViewModel";

@Component({
    selector: "rask-begransningsmatris",
    templateUrl: "./begransningsmatris.component.html",
    styleUrls: ["./begransningsmatris.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        HotDocComponent
    ]
})
export class BegransningsmatrisComponent implements OnChanges {
    hotDoc: HotDoc;
    @Input() rootForm: UntypedFormGroup;
    @Input() viewModel: ProduktdefinitionViewModel;

    private readonly raskModalService = inject(RaskModalService);

    initMatrisSettings = () => {
        this.hotDoc = this.viewModel.matrisdata.begransningsmatris.getBegransningsmatris(this.raskModalService, this.rootForm);
    };

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.viewModel && changes.viewModel.currentValue.vardematris !== changes.viewModel.previousValue?.vardematris) {
            this.initMatrisSettings();
        }
    }

    setKapkriterie = (kapkriteria: string) => {
        const cells = this.hotDoc.selectedCells();
        this.viewModel.vardematris.matrisdata.begransningsmatris.setKapkriteria(this.hotDoc, kapkriteria, cells);
    };
}
